import git from "../images/git-logo.png";
import javascript from "../images/JavaScript-logo.png";
import typescript from "../images/typescript-logo.png";
import react from "../images/react-logo.png";
import laravel from "../images/laravel-logo.png";
import php from "../images/php-logo.png";
import figma from "../images/figma-logo.png"
import mysql from "../images/MySQL-logo.png"
import postman from "../images/Postman-Logo.png"


export const skills = [
  {
    id: "javascript",
    title: "JavaScript",
    image: javascript,
  },
  {
    id: "typescript",
    title: "TypeScript",
    image: typescript,
  },
  {
    id: "php",
    title: "PHP",
    image: php,
  },
  {
    id: "react",
    title: "React",
    image: react,
  },
  {
    id: "laravel",
    title: "Laravel",
    image: laravel,
  },
  {
    id: "git",
    title: "Git",
    image: git,
  },
  {
    id: "postman",
    title: "Postman",
    image: postman,
  },
  {
    id: "mysql",
    title: "Mysql",
    image: mysql,
  },
  {
    id: "figma",
    title: "Figma",
    image: figma,
  },
];
